import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "network";

export const addOnApi = createApi({
    reducerPath: "addOnApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllReports: builder.query({
            query: ({ page, limit, search }) => ({
                url: `admin-addOns/reports?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response.data
        }),
        getAllSettings: builder.query({
            query: () => ({
                url: `admin-addOns/settings`
            }),
            transformResponse: (response) => response.data
        }),
        getPage: builder.query({
            query: ({id}) => ({
                url: `admin-addOns/page?id=${id}`
            }),
            transformResponse: (response) => response.data
        }),
        fetchDashboard: builder.mutation({
            query: (body) => ({ url: `admin-addOns/dashboard`, method: "POST", body: body,headers: {
                "Content-Type": "application/json",
              } }),
        }),
        getOverviewDashboard: builder.query({
            query: () => ({ url: `/backend/v1/dashboard/overview` }),
            transformResponse: (response) => response.data,
        }),
        getBeautyDashboard: builder.query({
            query: (period = "month") => ({ url: `/backend/v1/dashboard/beauty?period=${period}` }),
            transformResponse: (response) => response.data,
        }),
        getEcommerceDashboard: builder.query({
            query: () => ({ url: `/backend/v1/dashboard/ecommerce` }),
            transformResponse: (response) => response.data,
        }),
        getWellnessDashboard: builder.query({
            query: () => ({ url: `/backend/v1/dashboard/wellness` }),
            transformResponse: (response) => response.data,
        }),
        getSkinDashboard: builder.query({
            query: () => ({ url: `/backend/v1/dashboard/skin-analysis` }),
            transformResponse: (response) => response.data,
        }),
        getControls: builder.query({
            query: () => ({ url: `/backend/v1/settings/controls` }),
            transformResponse: (response) => response.data,
        }),
        updateControls: builder.mutation({
            query: (body) => ({ url: `/backend/v1/settings/controls`, method: "PUT", body }),
            transformResponse: (response) => response.data,
        }),
        updatePage: builder.mutation({
            query: ({id,dt}) => ({ url: `admin-addOns/page/${id}`, method: "PUT", body: dt,headers: {
                "Content-Type": "application/json",
              } }),
        }),
    })
})


export const { useGetAllReportsQuery, useGetAllSettingsQuery, useGetPageQuery, useUpdatePageMutation, useFetchDashboardMutation, useGetOverviewDashboardQuery, useGetBeautyDashboardQuery, useGetEcommerceDashboardQuery, useGetWellnessDashboardQuery, useGetSkinDashboardQuery, useGetControlsQuery, useUpdateControlsMutation } = addOnApi;
